<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "LiveClip",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      },{
        name: 'phone',
        placeholder: '手机号',
        type: 'input'
      } ],
      permission: {
        // add: 'liveClip:add',
        // update: 'liveClip:update',
        delete: 'liveClip:delete',
        deleteBatch: 'liveClip:deleteBatch'
      },
      url: {
        get: '/liveClip/listByCondition',
        add: '/liveClip/add',
        update: '/liveClip/update',
        delete: '/liveClip/delete/',
        delete_batch: '/liveClip/deleteBatch',
        status: '/liveClip/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        width: '',
      }/*,{
        field: 'keywordTimeSlicingId',
        label: '时间片段ID',
        // selectUrl: '/liveRoom/getAll',
        // selectData: [],
        // show: {
        //   type: 'select',
        // },
        show: true,
        width: '',
      }*/,{
        field: 'liveRoomId',
        label: '直播ID',
        // selectUrl: '/liveRoom/getAll',
        // selectData: [],
        // show: {
        //   type: 'select',
        // },
        show: true,
        width: '',
      }, {
        field: 'phone',
        label: '用户',
        show: true,
        width: '',
      },
        {
        field: 'liveRoomName',
        label: '直播间名称',
        show: true,
        width: '',
      },  {
          field: 'type',
          label: '剪辑类型',
          show: {
            type: 'select',
          },
          selectData:[{
            id: 1,
            name: '时间片段'
          },{
            id: 2,
            name: '口播',
          }],
          width: '',
        }, {
          field: 'taskId',
          label: '任务ID',
          show: true,
          width: '',
        }, {
          field: 'transcriptions',
          label: '参数',
          show: false,
          detail: true,
          width: '',
        }/*,
        {
        field: 'liveClipName',
        label: '剪辑名称',
        show: true,
        width: '',
      }*/,{
        field: 'liveClipUrl',
        label: '片段URL',
        show: true,
        width: '',
      }, {
          field: 'clipCoverImageUrl',
          label: '片段封面',
          img: true,
          show: true,
          width: '',
        },{
        field: 'videoDuration',
        label: '剪辑视频时长',
        show: true,
        width: '',
      },{
        field: 'tags',
        label: '标签',
        show: true,
        width: '',
      },{
        field: 'liveTime',
        label: '直播时间',
        show: true,
        width: '',
      }, {
          field: 'status',
          label: '状态',
          show: {
            type: 'tag',
            tags: [{
              key: 0,
              value: '失败',
              type: 'danger'
            }, {
              key: 1,
              value: '待剪辑',
              type: 'warning'
            }, {
              key: 3,
              value: '剪辑进行中',
              type: 'warning'
            }, {
              key: 4,
              value: '剪辑已完成',
              type: 'success'
            }]
          },
          detail: false,
          width: '',
        }, {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        }],
      operate: [],
      formFields: {
        addTitle: '直播片段',
        updateTitle: '直播片段',
        model: [{
          field: 'agentId',
          label: '代理：',
          type: 'select',
          placeholder: '请选择代理',
          rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
          selectUrl: '/agent/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        },{
          field: 'liveRoomId',
          label: '直播间Id：',
          type: 'select',
          placeholder: '请选择代理',
          rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
          selectUrl: '/liveRoom/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        },{
          field: 'phone',
          label: '用户',
          type: 'input',
          placeholder: '手机号',
          rules: [{message: '请输入手机号', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'liveRoomName',
          label: '直播间名称',
          type: 'input',
          placeholder: '直播间名称',
          rules: [{message: '请输入直播间名称', trigger: 'blur', required: false}],
          add: true,
          update: true,
        },  {
          field: 'clipCoverImageUrl',
          label: '片段封面URL',
          type: 'input',
          placeholder: '片段封面URL',
          rules: [{message: '请输入片段封面URL', trigger: 'blur', required: false}],
          add: true,
          update: true,
        }, {
          field: 'liveClipName',
          label: '剪辑名称',
          type: 'input',
          placeholder: '剪辑名称',
          rules: [{message: '请输入剪辑名称', trigger: 'blur', required: false}],
          add: true,
          update: true,
        },  {
          field: 'liveClipUrl',
          label: '剪辑保存URL',
          type: 'input',
          placeholder: '剪辑保存URL',
          rules: [{message: '请输入剪辑保存URL', trigger: 'blur', required: false}],
          add: true,
          update: true,
        },{
          field: 'tags',
          label: '标签',
          type: 'input',
          placeholder: '标签',
          rules: [{message: '请输入标签', trigger: 'blur', required: false}],
          add: true,
          update: true,
        },{
          field: 'videoDuration',
          label: '剪辑视频时长',
          type: 'input',
          placeholder: '剪辑视频时长',
          rules: [{message: '请输入剪辑视频时长', trigger: 'blur', required: false}],
          add: true,
          update: true,
        }, {
          field: 'liveTime',
          label: '直播时间',
          type: 'input',
          placeholder: '直播时间',
          rules: [{message: '请输入直播时间', trigger: 'blur', required: false}],
          add: true,
          update: true,
        }],
      }
    }
  }
}
</script>

<style scoped>

</style>
